import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

let token = localStorage.getItem( 'wipToken' );
let headers = {
  'Content-Type': 'application/json'
};

if( token != undefined && token != null && token.length > 0 ) {
  headers.Authorization = token;
  Vue.prototype.$token = token;
}

Vue.prototype.$http = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://wip.vacationpr.com/' : 'http://dev.softechpr.com/wip-invoices',
  withCredentials: false,
  headers: headers,
  validateStatus: function (status) {
      if (status >= 200 && status < 300 && status !== 204) {
          return true
      } else {
          return false
      }
  }
});

const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = 
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')


  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

Vue.mixin({
  methods: {
    logout() {
      localStorage.removeItem( 'wipToken' );
      Vue.prototype.$http = axios.create({
        baseURL: process.env.NODE_ENV === 'production' ? 'https://wip.vacationpr.com/' : 'http://dev.softechpr.com/wip-invoices',
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json'
        },
        validateStatus: function (status) {
            if (status >= 200 && status < 300 && status !== 204) {
                return true
            } else {
                return false
            }
        }
      });
    },
    login( token ) {
      localStorage.setItem( 'wipToken', token );
      Vue.prototype.$http = axios.create({
        baseURL: process.env.NODE_ENV === 'production' ? 'https://wip.vacationpr.com/' : 'http://dev.softechpr.com/wip-invoices',
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        validateStatus: function (status) {
            if (status >= 200 && status < 300 && status !== 204) {
                return true
            } else {
                return false
            }
        }
      });
    },
    isLoggedIn() {
      let token = localStorage.getItem( 'wipToken' );
      if( token != undefined && token != null && token.length > 0 )
        return true;

      return false;
    }
  }
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
